export default __webpack_public_path__ + "static/neue-haas-grotesk-display-66-medium-italic-eadf0bb20446717f57e40755656a0e7e.woff2";